<template>
  <div class="table-card-wrapper" :key="member.id">
    <div :class="['table-card', { 'table-card--revealed': !member.hidden }]">
      <div class="table-card__face table-card__back" v-if="member.hidden">
        <div class="table-card__pattern"></div>
      </div>
      <div class="table-card__face table-card__front" v-else>
        <span class="table-card__value">
          {{ $store.getters.deck[member.card] }}
        </span>
      </div>
    </div>
    <span :class="['table-card__name', { 'table-card__name--me': member.id === (me && me.id) }]">
      {{ member.name }}
    </span>
  </div>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
  name: "TableCard",
  props: ["member"],
  computed: {
    me() {
      return this.$store.getters.members.find(
        (mem) => mem.id == this.$socket.id
      );
    },
  },
});
</script>

<style scoped>
.table-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  animation: dealCard 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes dealCard {
  0% { opacity: 0; transform: translateY(-30px) scale(0.7) rotate(-5deg); }
  60% { transform: translateY(4px) scale(1.05) rotate(1deg); }
  100% { opacity: 1; transform: translateY(0) scale(1) rotate(0); }
}

.table-card {
  width: 56px;
  height: 76px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 600px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.table-card:hover {
  transform: translateY(-4px) scale(1.05);
}

.table-card__face {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-card__back {
  background: var(--card-bg, #fff);
  border: 2px solid var(--border-color);
  box-shadow:
    var(--shadow-card, 0 2px 8px rgba(0,0,0,0.1)),
    0 4px 12px rgba(0,0,0,0.05);
  position: relative;
  overflow: hidden;
}

.table-card__back::after {
  content: '';
  position: absolute;
  inset: 4px;
  border-radius: 6px;
  background: repeating-linear-gradient(
    45deg,
    var(--accent-subtle, rgba(79,124,255,0.06)),
    var(--accent-subtle, rgba(79,124,255,0.06)) 4px,
    transparent 4px,
    transparent 8px
  );
}

.table-card__pattern {
  display: none;
}

.table-card__front {
  background: var(--card-bg, #fff);
  border: 2px solid var(--accent);
  animation: cardReveal 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow:
    var(--shadow-card, 0 2px 8px rgba(0,0,0,0.1)),
    0 4px 16px var(--accent-glow, rgba(79,124,255,0.12));
}

@keyframes cardReveal {
  0% { transform: rotateY(90deg) scale(0.8); opacity: 0; }
  50% { transform: rotateY(-5deg) scale(1.05); }
  100% { transform: rotateY(0) scale(1); opacity: 1; }
}

.table-card__value {
  font-size: 1.3em;
  font-weight: 800;
  color: var(--accent);
}

.table-card__name {
  font-size: 0.68em;
  color: var(--text-tertiary);
  max-width: 64px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-weight: 500;
}

.table-card__name--me {
  font-weight: 700;
  color: var(--text-primary);
}
</style>
